import { getOnboardingContext, isHomeFlow } from "@helpers/localStorage"
import { useTranslation } from "react-i18next"

export default function MoneyBackGuarantee() {
  const { t } = useTranslation()
  const context = getOnboardingContext()
  const plansCopyKey =
    context === "cars"
      ? "pages.checkout.plansCars"
      : context === "pets"
        ? "pages.checkout.plansPets"
        : isHomeFlow()
          ? "pages.checkout.plansHome"
          : "pages.checkout.plans"

  return (
    <div className="rounded-2xl bg-linear-to-br from-green-50 to-blue-50 px-6 py-5 text-center shadow-xs">
      <h2 className="mb-4 text-base font-semibold text-black">
        {t(`${plansCopyKey}.moneyBackGuaranteeComponent.title`)}
      </h2>
      <p className="text-text-secondary text-sm leading-relaxed">
        {t(`${plansCopyKey}.moneyBackGuaranteeComponent.description`)}
      </p>
    </div>
  )
}
